module.exports = __webpack_public_path__ + "static/media/_vatican-city.6b67bc45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_vatican-city.svg
// module id = 2361
// module chunks = 7